import React, { useState } from "react";
import axiosInstance from "../../services/axiosComman";
import CreateOrEdit from "./from";
import { ViewMoreIcon } from "../../assets/icons";

function Viewmore({ fetcher, data}) {
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showMyMenu, setShowMyMenu] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenu(false);
  const [viewData, setViewData] = useState([]);

  async function getViewPage() {
    await axiosInstance.get(`/Standards/${data.id}`)
      .then((res) => {
        res.data?.data && setViewData(res.data?.data);
      })
      .catch((err) => console.log(err));
  }
  return (
    <>
      <div
        className="hover:drop-shadow-sm mr-2 py-2 px-[7px] rounded-3xl h-8 bg-white dropdown cursor-pointer relative"
        onClick={() => {
          setShowMyMenu(!showMyMenu);
          getViewPage();
        }}
      >
        <ViewMoreIcon/>
        <div className="hidden dropdown-menu">
          <div
            id="modal"
            onClick={handleOnCloseMenu}
            className="bg-transparent fixed inset-0 flex justify-center items-center "
          ></div>
          <div className="bg-white rounded-xl w-20 absolute -left-20 -top-1">
            <div className="grid p-1 rounded-t">
              <span
                className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer text-xs xl:text-sm"
                onClick={() => setShowMyModal(true)}
              >
                Edit
              </span>
            </div>
          </div>
        </div>
      </div>
      <CreateOrEdit
        onClose={handleOnClose}
        visible={showMyModal}
        data={data}
        refreshData={fetcher}
      />
    </>
  );
}

export default Viewmore;
